import { Input, Select } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { DatePicker } from '../DatePicker';

const { Option } = Select;

export default function ParkingAtModalContentOld({
  setChangedDateTime,
  dateRange,
  changeEvent,
  changedDateTime,
  hourminRangeFn,
  showTimeDate = false,
  deviceType,
  facility,
}) {
  const hourminRange = hourminRangeFn();
  const [ui, setUi] = useState({
    checkin: null,
    checkout: null,
    modCheckin: null,
    modCheckout: null,
    sleepAt: null,
  });

  useEffect(() => {
    const vcheckin = dayjs(dateRange.checkIn)
      .hour(Number(hourminRange.checkin.hour))
      .minute(Number(hourminRange.checkin.minute));
    const vcheckout = dayjs(dateRange.checkOut)
      .hour(Number(hourminRange.checkout.hour))
      .minute(Number(hourminRange.checkout.minute));
    setUi(
      changeEvent
        ? {
            checkin: vcheckin,
            checkout: vcheckout,
            modCheckin: vcheckin,
            modCheckout: vcheckout,
            sleepAt: dateRange.sleepAt,
          }
        : ({} as any)
    );
  }, [
    changeEvent,
    dateRange.checkIn,
    dateRange.checkOut,
    dateRange.sleepAt,
    hourminRange.checkin.hour,
    hourminRange.checkin.minute,
    hourminRange.checkout.hour,
    hourminRange.checkout.minute,
  ]);
  const today = dayjs();
  const changeCheckout = (date, hourmin) => {
    let newDate = ui.modCheckout ?? ui.checkout;
    if (date) {
      newDate = dayjs(date);
    }
    if (hourmin) {
      const [hour, min, period] = hourmin.split(/:|\W+/g);
      newDate = newDate.hour(Number(hour)).minute(Number(min)).second(0);
    }
    let checkin = null;
    if (newDate.isSame(ui.modCheckin) || ui.modCheckin.isAfter(newDate)) {
      checkin = newDate.subtract(1, 'day');
      if (checkin.isBefore(today) || hourmin) {
        if (hourmin) {
          console.log(hourmin, 'hourm');
          const [hour, min] = hourmin.split(/:|\W+/g);
          checkin = today.hour(Number(hour)).minute(Number(min)).second(0);
          newDate = checkin.add(1, 'day');
        } else {
          return;
        }
      }
    }

    setChangedDateTime({
      ...changedDateTime,
      checkOut: true,
      dtCheckout: newDate,
      checkIn: checkin ? true : changedDateTime.checkIn,
      dtCheckin: checkin ? checkin : changedDateTime.dtCheckin,
    });
    setUi({
      ...ui,
      modCheckout: newDate,
      modCheckin: checkin ? checkin : ui.modCheckin,
    });
  };
  const changeSleepAt = (sleepAt) => {
    setChangedDateTime({ ...changedDateTime, sleepAt: sleepAt });
    setUi({ ...ui, sleepAt });
  };
  const changeCheckin = (date, hourmin) => {
    let newDate = ui.modCheckin ?? ui.checkin;
    if (date) {
      newDate = dayjs(date);
    }
    if (hourmin) {
      const [hour, min, _period] = hourmin?.split(/:|\W+/g);
      newDate = newDate.hour(Number(hour)).minute(Number(min)).second(0);
    }

    let checkout = null;
    if (newDate.isSame(ui.modCheckout) || ui.modCheckout.isBefore(newDate)) {
      checkout = newDate.add(1, 'day');
    }

    if (facility.facilityParkingType == 4) {
      checkout = newDate.add(1, 'month');
    }
    setChangedDateTime({
      ...changedDateTime,
      checkIn: true,
      dtCheckin: newDate,
      checkOut: checkout ? true : changedDateTime.checkOut,
      dtCheckout: checkout ? checkout : changedDateTime.dtCheckout,
    });
    setUi({
      ...ui,
      modCheckin: newDate,
      modCheckout: checkout ? checkout : ui.modCheckout,
    });
  };
  if (!ui.checkin || !ui.checkout) return <></>;
  return (
    <div className="transition-opacity">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-14">
        <div>
          <label className="px-4 font-bold" htmlFor="checkIn">
            Start Date
          </label>
          <div className="px-1 w-full flex justify-start items-center flex-row rounded-full border bg-white md:block">
            <div
              className={`md:rounded-full md:pt-0 md:h-full ${
                deviceType === 'desktop' ? 'w-full' : ''
              }`}
            >
              {deviceType !== 'mobile' ? (
                <DatePicker
                  id="checkIn"
                  data-test-id="mob_start_date"
                  allowClear
                  value={ui.modCheckin}
                  format="MM/DD/YYYY"
                  onChange={(value) => {
                    changeCheckin(value, null);
                  }}
                  bordered={false}
                  className="w-full h-10"
                  size="middle"
                  disabledDate={(currentDate) =>
                    currentDate && currentDate < dayjs().startOf('day')
                  }
                />
              ) : (
                <Input
                  id="checkIn"
                  data-test-id="mob_start_date"
                  type="date"
                  required
                  inputMode="none"
                  value={ui.modCheckin?.format('YYYY-MM-DD')}
                  pattern="\d{4}-\d{2}-\d{2}"
                  placeholder="Starting parking at"
                  onChange={(evt) => {
                    changeCheckin(
                      evt.target.value,
                      ui.modCheckin?.format('HH:mm')
                    );
                  }}
                  bordered={false}
                  className={`md:w-full !p2 !px-2 !pt-2 md:pt-1`}
                />
              )}
            </div>
          </div>
        </div>
        <div>
          <label className="px-4 font-bold" htmlFor="checkOut">
            End Date
          </label>
          <div
            className={`w-full flex justify-start items-center flex-row rounded-full border bg-white md:block`}
          >
            <div
              className={`md:rounded-full md:pt-0 md:h-full ${
                deviceType === 'desktop' ? 'w-full' : ''
              }`}
            >
              {deviceType !== 'mobile' ? (
                <DatePicker
                  id="checkOut"
                  data-test-id="mob_end_date"
                  allowClear
                  value={ui.modCheckout}
                  format="MM/DD/YYYY"
                  onChange={(value) => {
                    changeCheckout(value, null);
                  }}
                  bordered={false}
                  className="w-full h-10"
                  size="middle"
                  disabled={facility.facilityParkingType == 4}
                  disabledDate={(currentDate) =>
                    currentDate < ui.modCheckin.startOf('day')
                  }
                />
              ) : (
                <Input
                  id="checkOut"
                  data-test-id="mob_end_date"
                  type="date"
                  required
                  inputMode="none"
                  value={ui.modCheckout?.format('YYYY-MM-DD')}
                  pattern="\d{4}-\d{2}-\d{2}"
                  placeholder="End parking at"
                  disabled={facility.facilityParkingType == 4}
                  onChange={(evt) => {
                    changeCheckout(
                      evt.target.value,
                      ui.modCheckout?.format('HH:mm')
                    );
                  }}
                  bordered={false}
                  className="md:w-full !p2 !px-3 !pt-2 md:pt-1"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {facility.facilityParkingType == 3 && (
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4 md:gap-14 mt-4">
          <div>
            <label className="px-4 font-bold" htmlFor="timeCheckIn">
              Hotel stay night
            </label>
            <div className="px-1 w-full"></div>
            <div className="rounded-full border bg-white">
              <Select
                id="sleep_at"
                className="w-full animate-fadeit py-2 px-3 border-none rounded-full"
                onChange={(value) => {
                  changeSleepAt(value);
                }}
                value={ui.sleepAt}
              >
                <Option value="1">Night of Check-In</Option>
                <Option value="2">Night of Check-Out</Option>
              </Select>
            </div>
          </div>
        </div>
      )}
      {showTimeDate && (
        <div className="grid grid-cols-2 gap-x-8 gap-y-2 mt-4">
          <div>
            <label className="px-4 font-bold" htmlFor="timeCheckIn">
              Start Time
            </label>
            <div className="px-1 w-full">
              <div className="rounded-full border bg-white">
                <Select
                  getPopupContainer={(triggerNode) => triggerNode.parentElement}
                  id="timeCheckIn"
                  onChange={(value) => {
                    changeCheckin(null, value);
                  }}
                  className="w-full animate-fadeit py-2 px-3 border-none rounded-full"
                  value={ui.modCheckin?.format('HH:mm')}
                >
                  <Option value="00:00">12:00 AM</Option>
                  <Option value="00:30">12:30 AM</Option>
                  <Option value="01:00">1:00 AM</Option>
                  <Option value="01:30">1:30 AM</Option>
                  <Option value="02:00">2:00 AM</Option>
                  <Option value="02:30">2:30 AM</Option>
                  <Option value="03:00">3:00 AM</Option>
                  <Option value="03:30">3:30 AM</Option>
                  <Option value="04:00">4:00 AM</Option>
                  <Option value="04:30">4:30 AM</Option>
                  <Option value="05:00">5:00 AM</Option>
                  <Option value="05:30">5:30 AM</Option>
                  <Option value="06:00">6:00 AM</Option>
                  <Option value="06:30">6:30 AM</Option>
                  <Option value="07:00">7:00 AM</Option>
                  <Option value="07:30">7:30 AM</Option>
                  <Option value="08:00">8:00 AM</Option>
                  <Option value="08:30">8:30 AM</Option>
                  <Option value="09:00">9:00 AM</Option>
                  <Option value="09:30">9:30 AM</Option>
                  <Option value="10:00">10:00 AM</Option>
                  <Option value="10:30">10:30 AM</Option>
                  <Option value="11:00">11:00 AM</Option>
                  <Option value="11:30">11:30 AM</Option>
                  <Option value="12:00">12:00 PM</Option>
                  <Option value="12:30">12:30 PM</Option>
                  <Option value="13:00">1:00 PM</Option>
                  <Option value="13:30">1:30 PM</Option>
                  <Option value="14:00">2:00 PM</Option>
                  <Option value="14:30">2:30 PM</Option>
                  <Option value="15:00">3:00 PM</Option>
                  <Option value="15:30">3:30 PM</Option>
                  <Option value="16:00">4:00 PM</Option>
                  <Option value="16:30">4:30 PM</Option>
                  <Option value="17:00">5:00 PM</Option>
                  <Option value="17:30">5:30 PM</Option>
                  <Option value="18:00">6:00 PM</Option>
                  <Option value="18:30">6:30 PM</Option>
                  <Option value="19:00">7:00 PM</Option>
                  <Option value="19:30">7:30 PM</Option>
                  <Option value="20:00">8:00 PM</Option>
                  <Option value="20:30">8:30 PM</Option>
                  <Option value="21:00">9:00 PM</Option>
                  <Option value="21:30">9:30 PM</Option>
                  <Option value="22:00">10:00 PM</Option>
                  <Option value="22:30">10:30 PM</Option>
                  <Option value="23:00">11:00 PM</Option>
                  <Option value="23:30">11:30 PM</Option>
                </Select>
              </div>
            </div>
          </div>
          <div>
            <label className="px-4 font-bold" htmlFor="timeCheckOut">
              End Time
            </label>
            <div className="px-1 w-full">
              <div className="rounded-full border bg-white">
                <Select
                  getPopupContainer={(triggerNode) => triggerNode.parentElement}
                  id="timeCheckOut"
                  onChange={(value) => {
                    changeCheckout(null, value);
                  }}
                  className="w-full animate-fadeit py-2 px-3 border-none rounded-full"
                  value={ui.modCheckout?.format('HH:mm')}
                  disabled={facility.facilityParkingType == 4}
                >
                  <Option value="00:00">12:00 AM</Option>
                  <Option value="00:30">12:30 AM</Option>
                  <Option value="01:00">1:00 AM</Option>
                  <Option value="01:30">1:30 AM</Option>
                  <Option value="02:00">2:00 AM</Option>
                  <Option value="02:30">2:30 AM</Option>
                  <Option value="03:00">3:00 AM</Option>
                  <Option value="03:30">3:30 AM</Option>
                  <Option value="04:00">4:00 AM</Option>
                  <Option value="04:30">4:30 AM</Option>
                  <Option value="05:00">5:00 AM</Option>
                  <Option value="05:30">5:30 AM</Option>
                  <Option value="06:00">6:00 AM</Option>
                  <Option value="06:30">6:30 AM</Option>
                  <Option value="07:00">7:00 AM</Option>
                  <Option value="07:30">7:30 AM</Option>
                  <Option value="08:00">8:00 AM</Option>
                  <Option value="08:30">8:30 AM</Option>
                  <Option value="09:00">9:00 AM</Option>
                  <Option value="09:30">9:30 AM</Option>
                  <Option value="10:00">10:00 AM</Option>
                  <Option value="10:30">10:30 AM</Option>
                  <Option value="11:00">11:00 AM</Option>
                  <Option value="11:30">11:30 AM</Option>
                  <Option value="12:00">12:00 PM</Option>
                  <Option value="12:30">12:30 PM</Option>
                  <Option value="13:00">1:00 PM</Option>
                  <Option value="13:30">1:30 PM</Option>
                  <Option value="14:00">2:00 PM</Option>
                  <Option value="14:30">2:30 PM</Option>
                  <Option value="15:00">3:00 PM</Option>
                  <Option value="15:30">3:30 PM</Option>
                  <Option value="16:00">4:00 PM</Option>
                  <Option value="16:30">4:30 PM</Option>
                  <Option value="17:00">5:00 PM</Option>
                  <Option value="17:30">5:30 PM</Option>
                  <Option value="18:00">6:00 PM</Option>
                  <Option value="18:30">6:30 PM</Option>
                  <Option value="19:00">7:00 PM</Option>
                  <Option value="19:30">7:30 PM</Option>
                  <Option value="20:00">8:00 PM</Option>
                  <Option value="20:30">8:30 PM</Option>
                  <Option value="21:00">9:00 PM</Option>
                  <Option value="21:30">9:30 PM</Option>
                  <Option value="22:00">10:00 PM</Option>
                  <Option value="22:30">10:30 PM</Option>
                  <Option value="23:00">11:00 PM</Option>
                  <Option value="23:30">11:30 PM</Option>
                </Select>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
